<template>
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title" id="assignDriverToBackupTRModalLabel">
        Backup history of "{{ backupTrip.backup_request_code }}"
      </h5>
      <button
        type="button"
        class="btn-close"
        data-bs-dismiss="modal"
        aria-label="Close"
        ref="modalCloseBtn"
      >
        <i class="bi bi-x-circle"></i>
      </button>
    </div>
    <div class="modal-body">
      <DefaultLoader v-if="isLoading"></DefaultLoader>
      <div v-else class="backup-history-table table-responsive">
        <CustomDataTable
          :filteredData="backupHistory"
          @fetchPaginatedData="fetchPaginatedData"
        >
          <table class="table">
            <thead>
              <tr>
                <th>SL</th>
                <th>Request By</th>
                <th>Request Time</th>
                <th>Assigned By</th>
                <th>Assign Time</th>
                <th>Price Updated By</th>
                <th>Percent Updated By</th>
                <th>Action</th>
                <th>Action By</th>
                <th>Action Time</th>
              </tr>
            </thead>
            <tbody>
              <template v-if="paginatedHistoryList.length > 0">
                <tr
                  v-for="(history, index) in paginatedHistoryList"
                  :key="index"
                >
                  <td>{{ index + 1 }}</td>
                  <td>
                    {{
                      history.requested_by
                        ? userInfoObj[history.requested_by]
                          ? userInfoObj[history.requested_by].name
                          : history.requested_by
                        : 'N/A'
                    }}
                  </td>
                  <td>
                    {{
                      format.date(
                        history.backup_request_date_time,
                        'DD/MM/YYYY, hh:mma'
                      )
                    }}
                  </td>
                  <td>
                    {{
                      history.assigned_by
                        ? userInfoObj[history.assigned_by]
                          ? userInfoObj[history.assigned_by].name
                          : history.assigned_by
                        : 'N/A'
                    }}
                  </td>
                  <td>
                    {{
                      format.date(
                        history.assigne_date_time,
                        'DD/MM/YYYY, hh:mma'
                      )
                    }}
                  </td>
                  <td>
                    {{
                      history.price_updated_by
                        ? userInfoObj[history.price_updated_by]
                          ? userInfoObj[history.price_updated_by].name
                          : history.price_updated_by
                        : 'N/A'
                    }}
                  </td>
                  <td>
                    {{
                      history.percent_updated_by
                        ? userInfoObj[history.percent_updated_by]
                          ? userInfoObj[history.percent_updated_by].name
                          : history.percent_updated_by
                        : 'N/A'
                    }}
                  </td>
                  <td>{{ history.action ? history.action : 'N/A' }}</td>
                  <td>
                    {{
                      history.action_by
                        ? userInfoObj[history.action_by]
                          ? userInfoObj[history.action_by].name
                          : history.action_by
                        : 'N/A'
                    }}
                  </td>
                  <td>
                    {{ format.date(history.created_at, 'DD/MM/YYYY, hh:mma') }}
                  </td>
                </tr>
              </template>
              <template v-else>
                <tr>
                  <td colspan="20" class="text-center text-danger">
                    No History Found!
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </CustomDataTable>
      </div>
    </div>
  </div>
</template>

<script>
import format from '../../store/format';
import userServiceAPI from '../../store/userServiceAPI';
import CustomDataTable from '../customDataTable/CustomDataTable.vue';

export default {
  props: ['backupTrip', 'backupHistory'],
  components: {
    CustomDataTable
  },
  data() {
    return {
      userInfoObj: {},
      paginatedHistoryList: [],
      isLoading: false,
      format
    };
  },
  watch: {
    backupHistory: {
      handler: function () {
        this.getUserDetails();
      },
      deep: true
    }
  },
  methods: {
    getUserDetails() {
      this.isLoading = true;
      let userCodes = [];

      this.backupHistory.forEach((history) => {
        if (history.action_by) {
          userCodes.push(history.action_by);
        }
        if (history.assigned_by) {
          userCodes.push(history.assigned_by);
        }
        if (history.percent_updated_by) {
          userCodes.push(history.percent_updated_by);
        }
        if (history.price_updated_by) {
          userCodes.push(history.price_updated_by);
        }
        if (history.requested_by) {
          userCodes.push(history.requested_by);
        }
      });

      userServiceAPI
        .getUserDetails(userCodes)
        .then((result) => {
          this.isLoading = false;
          this.userInfoObj = userServiceAPI.mapUsersIntoObject(
            result.data.data
          );
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    fetchPaginatedData(paginatedData) {
      this.paginatedHistoryList = paginatedData;
    }
  }
};
</script>

<style scoped>
.table {
  font-size: 13px;
  font-weight: 400;
}

.table thead > tr > th {
  vertical-align: bottom;
  border-bottom: 2px solid #f8f9fa;
  background: #f3f3f3;
}

.table tbody > tr > td {
  vertical-align: middle;
}
</style>
